<template>
  <nuxt-link
    :to="localePath(props.to, locale)"
    :class="$style.root"
  >
    <slot />
  </nuxt-link>
</template>

<script setup lang="ts">
const localePath = useLocalePath()

const props = defineProps({
  to: {
    type: [String, Object]
  },
  locale: {
    type: String,
    optional: true
  }
})
</script>

<style module>
.root[disabled] {
  pointer-events: none;
}
</style>
